import { useNavigate } from 'react-router-dom';

import { Button, Result, Status } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';

/**
 * Component to display if the user tries to access a page/route which doesn't exist
 * (i.e. fallback page for URLs not handled in react-router config).
 *
 * This is not for handling the case where an entity does not exist/cannot be accessed -
 * that should use specific error handling.
 *
 * Generally used as a final fallback element in each set of react-router Routes
 *
 * @example
 * ```tsx
 * return (
 *   <Routes>
 *     <Route path="a" element={<A />} />
 *     <Route path="b/*" element={<B />} />
 *     <Route path="c/:runId" element={<C />} />
 *     <Route path="*" element={<PageNotFound />} />
 *   </Routes>
 * );
 * ```
 */
export const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status={Status.ERROR}
      title={T`pageNotFound.title`}
      text={T`pageNotFound.text`}
      actions={<Button onClick={() => navigate(-1)} variant="solid">{T`pageNotFound.goBack`}</Button>}
    />
  );
};
